import { render, staticRenderFns } from "./bankModalAdd.vue?vue&type=template&id=4b204b2c&scoped=true"
import script from "./bankModalAdd.vue?vue&type=script&lang=js"
export * from "./bankModalAdd.vue?vue&type=script&lang=js"
import style0 from "./bankModalAdd.vue?vue&type=style&index=0&id=4b204b2c&prod&lang=scss&scoped=true"
import style1 from "./bankModalAdd.vue?vue&type=style&index=1&id=4b204b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b204b2c",
  null
  
)

export default component.exports